import { useNavigate } from "react-router-dom";
import { useSubscription } from "@/context/SubscriptionContext";
import { useAuth } from "@/context/AuthContext";
import { PaymentOptions } from "@/components/PaymentOptions";
import { PaymentFooter } from "@/components/PaymentLogos";
import { Logo } from "@/lib/brand";
import { CurrentPlan } from "@/pages/MyPlan";
import { Button } from "@/components/ui/button";
import { CircleNotch, SignOut, LockKey } from "@phosphor-icons/react";

function RenewalOnly() {
  const { logout } = useAuth();
  const { entitlement } = useSubscription();
  const navigate = useNavigate();
  const doLogout = async () => {
    await logout();
    navigate("/login");
  };
  return (
    <div className="min-h-screen bg-secondary/40" data-testid="blocked-subscription">
      <header className="flex items-center justify-between border-b border-border bg-card px-5 py-3">
        <Logo className="h-9 w-auto" testid="blocked-logo" />
        <Button variant="ghost" size="sm" onClick={doLogout} data-testid="blocked-logout">
          <SignOut size={16} className="mr-1.5" /> Sair
        </Button>
      </header>
      <div className="mx-auto max-w-5xl space-y-6 px-4 py-10">
        <div className="text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <LockKey size={28} weight="bold" />
          </div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">
            {entitlement?.plan ? "O seu plano expirou" : "O seu período de teste terminou"}
          </h1>
          <p className="mt-2 text-muted-foreground">Renove para continuar. Os seus dados estão guardados em segurança.</p>
        </div>
        <CurrentPlan />
        <PaymentOptions />
        <PaymentFooter />
      </div>
    </div>
  );
}

export function SubscriptionGate({ children }) {
  const { entitlement, loading } = useSubscription();
  const { user } = useAuth();
  if (user?.is_platform_admin) return children;
  if (!entitlement) {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <CircleNotch size={32} className="animate-spin text-primary" />
      </div>
    );
  }
  if (!entitlement) return null;
  if (!entitlement.entitled) return <RenewalOnly />;
  return children;
}
